// Org holidays (public.holidays, 20260604010000_modules.sql).
//
// Written only in Org Settings; any signed-in user can read them (hol_read), so the
// Workspace calendar needs no grant of its own. There is no unique index on
// `date`: one day can carry several holidays, and every consumer must show them all.
import { supabase } from './supabase';

export type HolidayKind = 'public' | 'optional' | 'company' | 'regional';
export type Holiday = { id: string; date: string; name: string; kind: HolidayKind };

export const HOLIDAY_KINDS: Record<
  HolidayKind,
  { label: string; tone: 'accent' | 'lilac' | 'success' | 'coral'; color: string }
> = {
  public: { label: 'Public', tone: 'accent', color: '#3B7BFF' },
  optional: { label: 'Optional', tone: 'lilac', color: '#B794F6' },
  company: { label: 'Company', tone: 'success', color: '#5CE4A8' },
  regional: { label: 'Regional', tone: 'coral', color: '#FF9A76' },
};

/** Holidays between two 'YYYY-MM-DD' keys, inclusive, oldest first. `error` is
 *  the failed read: dropped, it drew a month with no holidays in it (WS-V1). */
export async function listHolidays(
  from: string,
  to: string,
): Promise<{ data: Holiday[]; error: { message: string } | null }> {
  if (!supabase) return { data: [], error: null };
  const { data, error } = await supabase
    .from('holidays')
    .select('id, date, name, kind')
    .gte('date', from)
    .lte('date', to)
    .order('date');
  return { data: (data as Holiday[] | null) ?? [], error };
}
